import { Space } from "antd"

export default (props) => (
    <Space style={{width: '100%', position: 'fixed', bottom: 16, left: 0, zIndex: 0}}>
        <a href='//socoapp.ca/terms-and-conditions' target="_blank">Legal</a>
        <a href='mailto:info@soco.market'>Contact</a>
        <a href='//socoapp.ca/#walkthrough' target="_blank">Guide</a>
    </Space>
  )
  